import moment from 'moment';

const workSchedules = [
  {
    label: 'Última Semana',
    value: [
      moment()
        .subtract(1, 'weeks')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Quincena',
    value: [
      moment()
        .subtract(15, 'days')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Mes Anterior',
    value: [
      moment()
        .subtract(1, 'months')
        .format('L'),
      moment().format('L')
    ]
  }
];

const twelveMonths = [
  {
    label: '12 meses',
    value: [
      moment()
        .subtract(1, 'years')
        .format('L'),
      moment().format('L')
    ]
  }
];

const informesWorkSchedules = [
  {
    label: 'Semanal',
    value: [
      moment()
        .subtract(1, 'weeks')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Quincenal',
    value: [
      moment()
        .subtract(15, 'days')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Mensual',
    value: [
      moment()
        .subtract(1, 'months')
        .format('L'),
      moment().format('L')
    ]
  },
  {
    label: 'Anual',
    value: [
      moment()
        .subtract(1, 'years')
        .format('L'),
      moment().format('L')
    ]
  }
];

export { workSchedules, informesWorkSchedules, twelveMonths };
